
import React from 'react';
import DashboardCards from './DashboardCards';
import WorkersTable from './WorkersTable';
import RustyKaspaTable from './RustyKaspaTable';
import ZkasMinerCard from './ZkasMinerCard';

const DashboardTab = ({
  userData,
  workerFinance,
  poolData,
  k1PoolData,
  hashrates,
  workers,
  balances,
  earnings,
  activeWorkers,
  totalColor,
  isMobile,
  kasPrice,
  priceLoading,
  priceError,
  miningTotal,
  miningBalanceLoading,
  miningBalanceError,
  ledgerTotal,
  styles,
  formatNumber,
  getExpectedHashrate,
  timeUntilRefresh,
  formatTime,
  kasChange24h,
  kaspaData,
  kaspaError,
  kaspaFetchTime,
  usdcMiningBalance
}) => {
  return (
    <>
    <RustyKaspaTable
      kaspaData={kaspaData}
      error={kaspaError}
      kaspaFetchTime={kaspaFetchTime}
      showSummary={true}
      showWorkers={false}
    />
    <DashboardCards
      userData={userData}
      workerFinance={workerFinance}
      poolData={poolData}
      k1PoolData={k1PoolData}
      hashrates={hashrates}
      workers={workers}
      balances={balances}
      earnings={earnings}
      activeWorkers={activeWorkers}
      totalColor={totalColor}
      isMobile={isMobile}
      kasPrice={kasPrice}
      priceLoading={priceLoading}
      priceError={priceError}
      miningTotal={miningTotal}
      miningBalanceLoading={miningBalanceLoading}
      miningBalanceError={miningBalanceError}
      ledgerTotal={ledgerTotal}
      styles={styles}
      getExpectedHashrate={getExpectedHashrate}
      formatNumber={formatNumber}
      timeUntilRefresh={timeUntilRefresh}
      formatTime={formatTime}
      kasChange24h={typeof kasChange24h !== 'undefined' ? kasChange24h : null}
      kaspaData={kaspaData}
      kaspaError={kaspaError}
      kaspaFetchTime={kaspaFetchTime}
      usdcMiningBalance={usdcMiningBalance}
    />
    <RustyKaspaTable
      kaspaData={kaspaData}
      error={kaspaError}
      kaspaFetchTime={kaspaFetchTime}
      showSummary={false}
      showWorkers={true}
    />
    <WorkersTable
      userData={userData}
      workers={workers}
      isMobile={isMobile}
      styles={styles}
      formatNumber={formatNumber}
      getExpectedHashrate={getExpectedHashrate}
      isDetailsTab={false}
    />
    <ZkasMinerCard
      styles={styles}
      isMobile={isMobile}
      getExpectedHashrate={getExpectedHashrate}
      isDetailsTab={false}
    />
    </>
  );
};

export default DashboardTab;
